/* Farbenloewe UTM-Tracker Pixel (Vanilla, ~120 Zeilen). Blaupause §4 + §14.
 * Einbau im Theme:
 *   <script async src="https://t.farbenloewe.de/utm-tracker.js"
 *           data-endpoint="https://t.farbenloewe.de" data-shop="farbenloewe"></script>
 */
(function () {
  var s = document.currentScript || (function () { var a = document.getElementsByTagName('script'); return a[a.length - 1] })()
  var ENDPOINT = (s && s.getAttribute('data-endpoint')) || (location.origin)
  var SHOP = (s && s.getAttribute('data-shop')) || ''
  var LS = 'utm_visitor_id', SS = 'utm_session_id', ST = 'utm_session_ts', SESSION_MS = 30 * 60 * 1000

  function uuid() {
    try { return crypto.randomUUID() } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16) })
  }
  function getVisitorId() {
    try { var v = localStorage.getItem(LS); if (!v) { v = uuid(); localStorage.setItem(LS, v) } return v }
    catch (e) { return uuid() } // Private Mode: fluechtige ID pro Aufruf
  }
  function getSessionId() {
    try {
      var now = Date.now(), id = sessionStorage.getItem(SS), ts = parseInt(sessionStorage.getItem(ST) || '0', 10)
      if (!id || (now - ts) > SESSION_MS) { id = uuid(); sessionStorage.setItem(SS, id) }
      sessionStorage.setItem(ST, String(now)); return id
    } catch (e) { return uuid() }
  }

  var visitorId = getVisitorId()

  function send(payload) {
    var url = ENDPOINT.replace(/\/$/, '') + '/api/track'
    var body = JSON.stringify(payload)
    try {
      // Lektion 2: text/plain-Blob (kein Preflight, cross-origin zuverlaessig).
      var blob = new Blob([body], { type: 'text/plain' })
      if (navigator.sendBeacon && navigator.sendBeacon(url, blob)) return
    } catch (e) {}
    try { fetch(url, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }) } catch (e) {}
  }

  function track(eventName) {
    send({
      visitor_id: visitorId, session_id: getSessionId(), shop: SHOP,
      url: location.href, referrer: document.referrer || '',
      event: eventName || 'pageview'
    })
    if (!eventName) writeCartAttr() // §14B: visitor_id frueh in den Warenkorb (fuer server-seitige Conversion)
  }

  // Add-to-Cart-Event (Journey-Detail wie Hyros): fetch auf /cart/add abfangen — defensiv,
  // Original-Verhalten bleibt IMMER unangetastet. Themes mit Form-Submit statt AJAX sehen
  // stattdessen den /cart-Pageview (ausreichender Fallback).
  try {
    var _fetch = window.fetch
    window.fetch = function (input) {
      var p = _fetch.apply(this, arguments)
      try {
        var u = String((input && input.url) || input || '')
        if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(u)) {
          p.then(function (r) { if (r && r.ok) { track('add_to_cart'); writeCartAttr() } }).catch(function () {})
        }
      } catch (e) {}
      return p
    }
  } catch (e) {}

  // §14B: visitor_id als Shopify-Cart-Attribut (Produktfinder-Muster, ein Order-Hook liest beide).
  // Nur EINMAL pro Session schreiben — Cart-Attribute leben am Cart weiter, jede neue Session
  // schreibt erneut (deckt zwischenzeitlich neu entstandene Carts ab). Schont die Cart-API.
  function writeCartAttr() {
    if (!window.Shopify) return
    try { if (sessionStorage.getItem('utm_cart_written')) return } catch (e) {}
    try {
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ attributes: { utm_visitor_id: visitorId } })
      }).then(function (r) {
        if (r && r.ok) { try { sessionStorage.setItem('utm_cart_written', '1') } catch (e) {} }
      }).catch(function () {})
    } catch (e) {}
  }

  // §4: SPA-Navigation ueber history.pushState + popstate erfassen.
  function hook() {
    var push = history.pushState
    history.pushState = function () { push.apply(this, arguments); setTimeout(track, 50) }
    window.addEventListener('popstate', function () { setTimeout(track, 50) })
  }

  // identify: E-Mail an den Tracker melden (Hyros-Stil "Opted in"). Origin-gated am Server.
  // Gedrosselt: dieselbe E-Mail nur 1x pro Session senden.
  function identify(email) {
    email = String(email || '').trim().toLowerCase()
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return
    try { if (sessionStorage.getItem('utm_idf') === email) return } catch (e) {}
    var url = ENDPOINT.replace(/\/$/, '') + '/api/identify'
    var body = JSON.stringify({ visitor_id: visitorId, email: email, shop: SHOP })
    try {
      fetch(url, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } })
        .then(function (r) { if (r && r.ok) { try { sessionStorage.setItem('utm_idf', email) } catch (e) {} } }).catch(function () {})
    } catch (e) {}
  }

  // Auto-Capture wie Hyros: (a) Formular-Submits mit E-Mail-Feld (Newsletter-Formulare, Popups),
  // (b) AJAX-Signups an /subscribe (Marketing-Modul). Beides defensiv, best effort.
  document.addEventListener('submit', function (ev) {
    try {
      var f = ev.target; if (!f || !f.querySelector) return
      var inp = f.querySelector('input[type="email"], input[name*="email" i]')
      if (inp && inp.value) identify(inp.value)
    } catch (e) {}
  }, true)
  // (fetch ist oben bereits fuer /cart/add gewrappt — hier haengen wir /subscribe an denselben Wrapper)
  try {
    var _fetch2 = window.fetch
    window.fetch = function (input, init) {
      try {
        var u = String((input && input.url) || input || '')
        if (/\/subscribe(\?|$)/.test(u) && init && init.body) {
          var m = String(init.body).match(/"email"\s*:\s*"([^"]+)"/) || String(init.body).match(/email=([^&]+)/)
          if (m) identify(decodeURIComponent(m[1]))
        }
      } catch (e) {}
      return _fetch2.apply(this, arguments)
    }
  } catch (e) {}

  // Oeffentliche API (Blaupause §4.5)
  window.utmTracker = {
    get visitor_id() { return visitorId },
    get session_id() { return getSessionId() },
    track: track,
    identify: identify,
    convert: function () { /* Conversions kommen server-seitig (§10), Browser meldet keine Kaeufe */ }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') { hook(); track() }
  else window.addEventListener('DOMContentLoaded', function () { hook(); track() })
})()
